import FocusTrap from 'focus-trap-react';
import { fromJS } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import { showedShareModal, showShareCoachmark } from '../../actions/Share';
import { loadFbSdkAndUpdatetokenValidity } from '../../actions/Social';
import { PandoraTypes } from '../../constants/SourceTypes';
import * as ShareUtils from '../../lib/ShareUtils';
import ShareModal from '../ShareModal/ShareModal';

import { ModalContainer } from './Modal';

import './ModalShare.scss';

class ModalShare extends React.Component {
  static propTypes = {
    childId: PropTypes.string,
    parentSourceId: PropTypes.string, // id that ModalShare Receives
    parentSourceType: PropTypes.oneOf(Object.values(PandoraTypes)),
    onClose: PropTypes.func,
    showedShareModal: PropTypes.func,
    showShareCoachmark: PropTypes.func.isRequired,
    loadFbSdkAndUpdatetokenValidity: PropTypes.func.isRequired,
    tabObjects: ImmutablePropTypes.listOf(PropTypes.object).isRequired,
  };

  componentDidMount() {
    // TODO: Move loading Facebook SDK into Domains
    this.props.loadFbSdkAndUpdatetokenValidity();
    this.logViewed();
  }

  logViewed = () => {
    const sourceId = this.props.parentSourceId || this.props.childId;
    const parentSource = this.props.parentSourceType;

    this.props.showedShareModal({ parentSource, sourceId });
  };

  render() {
    const focusTrapOptions = {
      onDeactivate: this.props.onClose,
    };
    return (
      <ModalContainer className='ModalContainer__ModalShare'>
        <FocusTrap focusTrapOptions={focusTrapOptions}>
          <ShareModal
            tabObjects={this.props.tabObjects.toJS()}
            onClose={this.props.onClose}
            showShareCoachmark={this.props.showShareCoachmark}
          />
        </FocusTrap>
      </ModalContainer>
    );
  }
}

export function mapStateToProps(state, ownProps) {
  const { childId, parentSourceId, parentSourceType } = ownProps;
  const tabObjects = ShareUtils.generateShareTabObjects(state, {
    childId,
    parentSourceId,
    parentSourceType,
  });

  return {
    tabObjects: fromJS(tabObjects),
  };
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      showShareCoachmark,
      showedShareModal,
      loadFbSdkAndUpdatetokenValidity,
    },
    dispatch,
  );
};

const enhance = compose(connect(mapStateToProps, mapDispatchToProps));

export default enhance(ModalShare);
